import Navbar from "../components/Navbar/Navbar";
import Footer from "../components/Footer/Footer";
import React from "react";
import img1 from "../assets/left.jpg";
import Hero from "../components/Main/Presentation/SearchFlight";
import "../components/Booking/BookFlight.css";
import ConfirmBooking from "../components/Booking/ConfirmBooking";

const BookFlight = () => {
    const baseCost = Math.floor((Math.random() * (10 - 5 + 1)) + 5) * 100;
    return (
            <div className="bookFligthPage">
                <Navbar/>
                <Hero cName="hero-mid book-flight" heroImg={img1} title="Book to fly!" text="Few more steps..."/>
                <ConfirmBooking baseCostValue={baseCost} />
                <Footer/>
            </div>
    );
};

export default BookFlight;